module.exports = __webpack_public_path__ + "img/btn_menu_bs.a7071928.png";